import { render, staticRenderFns } from "./PresumptiveList.vue?vue&type=template&id=07b93a57"
import script from "./PresumptiveList.vue?vue&type=script&lang=js"
export * from "./PresumptiveList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports